export default class TimeStamp {
    static getTodayString() {
        const date = new Date();
        let day = date.getDate();
        day = day.toString().padStart(2, "0");
        let month = date.getMonth() + 1;
        month = month.toString().padStart(2, "0");
        const year = date.getFullYear();
        return year + "-" + month + "-" + day;
    }
    static getLastDayOfMonthYear(month, day){
        const date = new Date();
        let monthTemp = date.getMonth() + 1;
        monthTemp = monthTemp.toString().padStart(2, "0");
        const year = month < monthTemp ? date.getFullYear() + 1 : date.getFullYear();
        return year + "-" + month + "-" + day;
    }
    static getFirstDayOfMonthYear(month, day){
        const date = new Date();
        const year = date.getFullYear();
        return year + "-" + month + "-" + day;
    }
    static getGMTTimestamp(){
        const localDate = new Date();
        const localUTC = localDate.getTime();
        const GMT_UTC = localUTC + localDate.getTimezoneOffset()* 60 * 1000;
        return GMT_UTC;
    }
    static getGMTTimestampForTextDate(date){
        const localDate = new Date(date);
        const localUTC = localDate.getTime();
        const GMT_UTC = localUTC + localDate.getTimezoneOffset()* 60 * 1000;
        return GMT_UTC;
    }
    static getTimestampForDateUncorrected(type, date){
        const localDate = new Date(date);
        let localUTC = localDate.getTime() + localDate.getTimezoneOffset()* 60 * 1000
        if (type === 'until') {
            localUTC += 86400000;         // +86400000 => nächster Kalendertag 0h00
        }
        return localUTC;
    }
    static getTimestampForDate(type, date){
        const localDate = new Date(date);
        let localUTC = localDate.getTime() + (localDate.getTimezoneOffset()* 60 * 1000) * 2; // *2 wegen Korrektur des Fehlers 3.7.2023
        if (type === 'until') {
            localUTC += 86400000;         // +86400000 => nächster Kalendertag 0h00
        }
        return localUTC;
    }
    static getDateForTimestamp(type, timestamp) {
        const correctedTS = type === 'until' ? timestamp - 86400000 : timestamp;
        return TimeStamp.getDateText(correctedTS);
    }
    static getLocalTime(GMT_UTC, short){
        const localUTC = GMT_UTC - new Date().getTimezoneOffset()* 60 * 1000;
        const date = new Date(localUTC);
    // Hours part from the timestamp
        let hours = '0' + date.getHours();
        hours = hours.substring(hours.length-2)
    // Minutes part from the timestamp
        const minutes = "0" + date.getMinutes();
    // Seconds part from the timestamp
        const seconds = "0" + date.getSeconds();
    // Will display time in 10:30:23 format
        let formattedTime = hours + ':' + minutes.substr(-2);
        formattedTime += short ? '' : ':' + seconds.substr(-2);
        return formattedTime;
    }
    static getLocalDate(GMT_UTC) {
        const localUTC = GMT_UTC - new Date().getTimezoneOffset()* 60 * 1000;
        return TimeStamp.getDateText(localUTC);
    }
    static getLocalDateAndTime(GMT_UTC, short) {
        const localUTC = GMT_UTC - new Date().getTimezoneOffset()* 60 * 1000;
        let date = TimeStamp.getDateText(localUTC);
        return TimeStamp.getStringDotDateFromString(date) + ' - ' + TimeStamp.getLocalTime(GMT_UTC, short);
    }
    static getDateTodayYesterdayOthers(ts, delta){
        const dateToBeChecked = new Date(ts);
        const dateToday = new Date();
        const dateYesterday = new Date(dateToday - 3600*1000*24);
        if( dateToBeChecked.setHours(0,0,0,0) == dateToday.setHours(0,0,0,0) ) {
            return 'heute';
        } else if ( dateToBeChecked.setHours(0,0,0,0) == dateYesterday.setHours(0,0,0,0) ) {
            return 'gestern';
        } else {
            //console.error ("ACHTUNG: Format in timeStamp.js noch nicht definiert", ts);
            return Math.round(delta/(365*24*60*60)) + ' Jahr';
            //return i18n.d(dateToBeChecked, 'longDate', 'de');
        }
    }
    static getTimeSince(GMT_UTC){
        const localUTC = GMT_UTC - new Date().getTimezoneOffset()* 60 * 1000;
        const localDate = new Date();
        const delta = (localDate - localUTC)/1000;
        if ( delta > 365*24*60*60 ) {
            return TimeStamp.getDateTodayYesterdayOthers(GMT_UTC, delta)
        } else if ( delta > 7*24*60*60) {
            return Math.round(delta/(7*24*60*60)) + ' Wo.';
        } else if ( delta > 24*60*60) {
            return Math.round(delta/(24*60*60)) + ' T.';
        } else if ( delta > 60*60) {
            return Math.round(delta/(60*60)) + ' Std.';
        } else {
            return Math.round(delta/60) + " Min.";
        }
        //return Math.round(delta/60);
    }
        static getDateText(localUTC){
            const date = new Date(localUTC);
            let day = date.getDate();
            day = day.toString().padStart(2, "0");
            let month = date.getMonth() + 1;
            month = month.toString().padStart(2, "0");
            const year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }
        static getDateTextLocal(GMT_UTC){
            const localUTC = GMT_UTC - new Date().getTimezoneOffset()* 60 * 1000;
            return TimeStamp.getDateText(localUTC);
        }

    static getFileTimeStamp() {
        const localDate = new Date();
        const localUTC = localDate.getTime();
    // date
        const date = new Date(localUTC);
        let day = date.getDate();
        day = day.toString().padStart(2, "0");
        let month = date.getMonth() + 1;
        month = month.toString().padStart(2, "0");
        const year = date.getFullYear();
    // time
        // Hours part from the timestamp
        const hours = date.getHours();
        // Minutes part from the timestamp
        const minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        const seconds = "0" + date.getSeconds();
    // return
        return year + month + day + "_" + hours + minutes.substr(-2) + seconds.substr(-2);
    }

    static getStringFromDotDate(stringDate){
        let dateParts = stringDate.split('.');
        return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
    }

    static getStringDotDateFromString(stringDate, short){
        let dateParts = stringDate.split('-');
        return !short ?  dateParts[2] + "." + dateParts[1] + "." +  dateParts[0] :
                         dateParts[2] + "." + dateParts[1] + "." +  dateParts[0].substring(2,4);
    }

    static getDateStringFromSlashDateTimeUS(stringDate){
        // input: mm/dd/yyyy hh:mm:ss
        // output: yyyy-mm-dd
        // used for: excel import
        let dateParts = stringDate.split(' ');
        dateParts = dateParts[0].split('/');
        return dateParts[2] + "-" + dateParts[0] + "-" + dateParts[1];
    }

    static getTimeShortStringFromSlashDateTimeUS(stringDate){
        // input: mm/dd/yyyy hh:mm:ss
        // output: hh:mm
        // used for: excel import
        let dateParts = stringDate.split(' ');
        return dateParts[1].substr(0,5);
    }


    static getDiffInFullYears(dateString){
        const today = this.getTodayString();
        let yearDiff = parseInt(today.substr(0,4)) - parseInt(dateString.substr(0,4));
        const monthToday = parseInt(today.substr(6,2));
        const monthDate = parseInt(dateString.substr(6,2));
        if ( monthToday < monthDate ) {
            yearDiff--;
        } else if ( monthToday === monthDate ) {
            const dayToday = parseInt(today.substr(9,2));
            const dayDate = parseInt(dateString.substr(9,2));
            if ( dayDate > dayToday ) {
                yearDiff--;
            }
        }
        return yearDiff;
    }

    static getTimeStampDeltaInHours(delta){
        let seconds = delta/1000;
        const hours = Math.floor(seconds / (60*60));
        const mins =  ("0" + Math.floor((seconds - hours * 60 * 60) / 60)).substr(-2);
        return hours + 'h' + mins;
    }

    static getLocalStringFromGMTts(GMTts){
        const localTs = GMTts - new Date().getTimezoneOffset()* 60 * 1000;
        let options = { year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'};
        let dateFormated = new Date(localTs);
        return dateFormated.toLocaleDateString('de', options);
    }

    static getAgeInYears(birthday){
        const dob = new Date(birthday +' 00:00:00')
        var diff_ms = Date.now() - dob.getTime();
        var age_dt = new Date(diff_ms);
        return Math.abs(age_dt.getUTCFullYear() - 1970);
    }

}